<style lang="scss">
    @import '~@/assets/css/var';
    .my-form {
        border-top: 1px solid $border;
        .el-form-item {
            margin-bottom: 0;
            border-bottom: 1px solid $border;
        }

        .el-form-item__label {
            line-height: 45px;
            background: #f5f5f5;
        }
        .el-form-item__content {
            line-height: 45px;
            height: 45px;
            padding: 0 10px;
            > [class^="el-"] {
                width: 100%;
            }
        }
        .el-form-item__error {
            display: none;
        }
    }
</style>
<template>
    <my-drawer :show.sync="dialog.show" title="详情" @changeFullScreen="changeFullScreen">
        <div class="drawer-panel">
            <el-form ref="form" class="my-form" :model="dialog.form" label-width="120px">
                <el-row>
                    <el-col v-for="(col, i) in cols" :key="i" :span="!max||col.inline?24:12">
                            <el-form-item :key="i" :prop="col.key" :label="col.value" v-if="col.viewDetail && col.type !== $variable.colType.NEDITOR">
                                <template v-if="col.type === $variable.colType.SELECT">
                                    <template v-if="dialog.form[col.key + 'Name']||!col.param.keyValue">
                                        <!--<el-input-->
                                            <!--v-model="dialog.form[col.key + 'Name']"-->
                                            <!--readonly="readonly"></el-input>-->
                                        {{dialog.form[col.key + 'Name']}}
                                    </template>
                                    <template v-else>
                                        <!--<el-input-->
                                            <!--v-model="col.param.keyValue[dialog.form[col.key]]"-->
                                            <!--readonly="readonly"></el-input>-->
                                        {{col.param.keyValue[dialog.form[col.key]]}}
                                    </template>
                                    <!--                        {{dialog.form[col.key + 'Name']||!col.param.keyValue?dialog.form[col.key + 'Name']:col.param.keyValue[dialog.form[col.key]]}}-->
                                </template>
                                <template v-else-if="col.type === $variable.colType.NEDITOR">
                                    <vue-neditor-wrap  ref="neditor" @ready="ready" v-if="ue.finished" v-model="ue.content"
                                                       :config="ue.config" :destroy="false"></vue-neditor-wrap>
                                </template>
                                <template v-else-if="col.type === $variable.colType.IMG">
                                    <ls-upload :read="true" v-model="dialog.form[col.key]" ></ls-upload>
                                </template>
                                <template v-else>
                                    <!--<el-input-->
                                        <!--v-model="dialog.form[col.showKey ? col.showKey : col.key]"-->
                                        <!--readonly="readonly"></el-input>-->
                                    {{dialog.form[col.showKey ? col.showKey : col.key]}}
                                </template>
                            </el-form-item>
                        </el-col>
                </el-row>
            </el-form>
        </div>

        <div style="padding: 15px 15px 70px; margin-top:-30px">
            <vue-neditor-wrap ref="neditor" @ready="ready" v-if="ue.finished && hasUE" v-model="ue.content"
                              :config="ue.config" :destroy="false"></vue-neditor-wrap>
        </div>
    </my-drawer>
</template>

<script>
    export default {
        data() {
            return {
                max: false,
                // ue参数
                ue: {
                    finished: false,
                    config: {
                        // 你的UEditor资源存放的路径,相对于打包后的index.html
                        UEDITOR_HOME_URL: process.env.NODE_ENV === 'development' ? '/neditor/' : '/neditor/',
                        // 编辑器不自动被内容撑高
                        autoHeightEnabled: false,
                        // 初始容器高度
                        initialFrameHeight: 350,
                        // 初始容器宽度
                        initialFrameWidth: '100%',
                        // 关闭自动保存
                        enableAutoSave: false,
                        // 是否只读
                        readonly: true,
                    },
                    content: '',
                },

                hasUE: false,
            }
        },

        props: {
            // 弹窗相关参数
            dialog: {},

            cols: {},
        },
        mounted() {
            setTimeout(() => {
                if (this.dialog.isRich) {
                    //     // this.ue.config.initialFrameWidth = this.$refs.form.$el.clientWidth
                    //     this.ue.content = this.dialog.form.contentText;
                    this.ue.finished = true;
                }
            }, 300)

            if(this.dialog.form.contentText) {
                this.ue.content = this.dialog.form.contentText;
            }
        },
        computed: {},
        methods: {
            ready() {
                this.hasUE && (this.$refs.neditor.readyValue = this.dialog.form.contentText || '')

            },
            changeFullScreen() {
                this.max = !this.max;
            }
        },
        created() {
            for (let i = 0; i < this.cols.length; i += 1) {
                if (this.cols[i].type === this.$variable.colType.NEDITOR) {
                    this.hasUE = true
                    break
                }
            }
        },
    }
</script>
